export default __webpack_public_path__ + "static/media/event.bf282656.svg";